/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ExportInputs */

const en_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare`)
};

const ru_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const es_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const zh_cn2_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出`)
};

const hi_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात`)
};

const pt_pt2_audio_embed_export_export = /** @type {(inputs: Audio_Embed_Export_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Audio_Embed_Export_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_export = /** @type {((inputs?: Audio_Embed_Export_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_export(inputs)
	if (locale === "de") return de_audio_embed_export_export(inputs)
	if (locale === "it") return it_audio_embed_export_export(inputs)
	if (locale === "ru") return ru_audio_embed_export_export(inputs)
	if (locale === "es") return es_audio_embed_export_export(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_export(inputs)
	if (locale === "ja") return ja_audio_embed_export_export(inputs)
	if (locale === "hi") return hi_audio_embed_export_export(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_export(inputs)
	return en_audio_embed_export_export(inputs)
});